import { render, staticRenderFns } from "./FooterButtons.vue?vue&type=template&id=266fa236&scoped=true"
import script from "./FooterButtons.vue?vue&type=script&lang=js"
export * from "./FooterButtons.vue?vue&type=script&lang=js"
import style0 from "./FooterButtons.vue?vue&type=style&index=0&id=266fa236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266fa236",
  null
  
)

export default component.exports